module.exports = __webpack_public_path__ + "img/Group3180.ce19813f.png";